/* Step1Form.js */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import {
  createProduct,
  fetchProduct,
  fetchProducts,
} from "../../../network/fetch"; // Assurez-vous que le chemin est correct
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";
import State from "../State";

const Step1Form = () => {
  const wait = (ms) =>
    new Promise((resolve) => {
      console.log("=== `waiting ${ms}ms` === Step1Form.js === key: 462862 ===");
      console.dir(`waiting ${ms}ms`, { depth: null, colors: true });
      console.log("=================================");
      setTimeout(resolve, ms);
    });

  const navigate = useNavigate();

  // Définir le nombre total d'étapes et l'étape actuelle
  const total_steps = 5; // Par exemple, s'il y a 5 étapes au total
  const current_step = 1; // Étape actuelle
  const dateInputRef = useRef(null);

  const [txUri, setTxUri] = useState(null);
  const [tutorialStep, setTutorialStep] = useState(0);
  const [docIsSaved, setDocIsSaved] = useState(false);

  const generateUniqueId = (nbrBlocs = 3, nbrChars = 6) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const getRandomChars = (length) => {
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    };
    let blocs = [];
    for (let i = 0; i < nbrBlocs; i++) {
      blocs.push(getRandomChars(nbrChars));
    }
    return blocs.join("-");
  };

  // État pour les champs du formulaire
  const [formData, setFormData] = useState({
    productName: "",
    uniqueId: "",
    manufacturer: "",
    manufacturingDate: new Date().toISOString().split("T")[0],
    productType: "",
    estimatedLifespan: "",
    certifications: "",
    technicalSpecifications: "",
    productTypeConfidential: false,
    estimatedLifespanConfidential: false,
    certificationsConfidential: false,
    technicalSpecificationsConfidential: false,
  });

  // Générer l'ID unique lors du montage du composant
  useEffect(() => {
    const uniqueId = generateUniqueId(3, 6);
    State.batteryProductData.productId = uniqueId;
    setFormData((prevData) => ({
      ...prevData,
      uniqueId: uniqueId,
    }));
  }, []);

  // État pour gérer les erreurs et le chargement
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const dppNextStep = (e) => {
    e.preventDefault();
    //State.defaultClient = null;
    navigate("/dpp/step2", {
      replace: true,
    });
    return;
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données (1/2)</p>
          <p>
            En tant que constructeur de batteries, vous êtes chargé de la
            création de la fiche produit de vos batteries. Vous complétez donc
            un formulaire dans votre système informatique et les données vont
            être enregistrées également sur la blockchain et rendues disponibles
            à tous les acteurs qui en ont besoin.
          </p>
        </>
      ),
      position: { top: "100px", left: "50%", transform: "translateX(-50%)" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Confidentialité (2/2)</p>{" "}
          <p>
            A titre démonstratif, vous pouvez choisir de cacher certaines
            informations aux autres acteurs afin d’en assurer la
            confidentialité.
          </p>
        </>
      ),
      showArrow: "left",
      position: { top: "600px", left: "73%", width: "350px" },
      closeLabel: "hidden",
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);
  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">
            Vos informations ont été enregistrées avec succès
          </p>
          <p>
            Vous avez enregistré les informations de la batterie. Ces données
            sont désormais accessibles via la blockchain pour les autres acteurs
            de la chaîne. Cliquez sur le bouton ci-dessous pour consulter les
            informations brutes disponibles sur la blockchain.
          </p>
        </>
      ),
      closeLabel: "hidden",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e) => {
        dppNextStep(e);
      },
      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  // Gestion du changement d'entrée
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Préparation des données pour l'API
    const productData = {
      productId: formData.uniqueId,
      productName: formData.productName,
      productType: formData.productType,
      Manufacturer: formData.manufacturer,
      manufacturingDate: formData.manufacturingDate,
      estimatedLifetime: formData.estimatedLifespan,
      certifications: formData.certifications,
      specifications: formData.technicalSpecifications,
      pictureUri: "",
    };

    try {
      const response = await createProduct(productData);

      if (response.success) {
        // Rediriger vers l'étape suivante en cas de succès
        //navigate('/dpp/step2', { replace: true });
        console.log("=== response === Step1Form.js === key: 962796 ===");
        console.dir(response, { depth: null, colors: true });
        console.log("=================================");

        setTxUri(response.data.tx_uri);

        State.batteryProductData = {
          ...response.productData,
          ...response.data,
        };

        console.log("=== State === Step1Form.js === key: 711507 ===");
        console.dir(State, { depth: null, colors: true });
        console.log("=================================");

        setDocIsSaved(true);

        setTutorialSteps(submitedStep);
        setTutorialStep(0);
      } else {
        // Gérer les erreurs renvoyées par l'API
        setError("Erreur lors de la création du produit. Veuillez réessayer.");
        console.error("Erreur API:", response.error);
      }
    } catch (err) {
      setError("Une erreur est survenue. Veuillez réessayer.");
      console.error("Erreur de soumission:", err);
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return (
      formData.productName &&
      formData.uniqueId &&
      formData.manufacturer &&
      formData.manufacturingDate &&
      formData.productType &&
      formData.estimatedLifespan &&
      formData.certifications &&
      formData.technicalSpecifications
    );
  };

  return (
    <form onSubmit={handleSubmit} className="container form-2">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={
            tutorialSteps[tutorialStep].handleNextTutorialStep ||
            handleNextTutorialStep
          }
          onClose={handleCloseTutorial}
          txUrl={txUri}
          showArrow={tutorialSteps[tutorialStep].showArrow || false}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}
      <div className="fiels-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-switch-main">
            <div className="spacer"></div>
            <p className="form-switchs-label">Données confidentielles</p>
          </div>
          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="productName" className="form-label">
                Nom du produit
              </label>
              <input
                type="text"
                className="form-control"
                id="productName"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                required
                placeholder="Ex: Batterie CATL 3000 mAh"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="uniqueId" className="form-label">
                Identifiant unique
              </label>
              <input
                type="text"
                className="form-control"
                id="uniqueId"
                name="uniqueId"
                value={formData.uniqueId}
                readOnly
                placeholder="Ex: ABC123-DEF456"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="manufacturer" className="form-label">
                Fabricant
              </label>
              <input
                type="text"
                className="form-control"
                id="manufacturer"
                name="manufacturer"
                value={formData.manufacturer}
                onChange={handleChange}
                required
                placeholder="Ex: CATL"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="manufacturingDate" className="form-label">
                Date de fabrication
              </label>
              <input
                type="date"
                className="form-control"
                id="manufacturingDate"
                name="manufacturingDate"
                value={formData.manufacturingDate}
                onChange={handleChange}
                ref={dateInputRef}
                required
                placeholder="jj/mm/aaaa"
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Icône de date" />
              </span>
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="productType" className="form-label">
                Type de produit
              </label>
              <input
                type="text"
                className="form-control"
                id="productType"
                name="productType"
                value={formData.productType}
                onChange={handleChange}
                required
                placeholder="Ex: Batterie rechargeable"
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="productTypeConfidential"
                name="productTypeConfidential"
                checked={formData.productTypeConfidential}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="estimatedLifespan" className="form-label">
                Durée de vie estimée
              </label>
              <input
                type="text"
                className="form-control"
                id="estimatedLifespan"
                name="estimatedLifespan"
                value={formData.estimatedLifespan}
                onChange={handleChange}
                required
                placeholder="Ex: 5 ans"
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="estimatedLifespanConfidential"
                name="estimatedLifespanConfidential"
                checked={formData.estimatedLifespanConfidential}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="certifications" className="form-label">
                Certifications obtenues
              </label>
              <input
                type="text"
                className="form-control"
                id="certifications"
                name="certifications"
                value={formData.certifications}
                onChange={handleChange}
                required
                placeholder="Ex: ISO 9001"
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="certificationsConfidential"
                name="certificationsConfidential"
                checked={formData.certificationsConfidential}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="technicalSpecifications" className="form-label">
                Capacité énergétique
              </label>
              <input
                type="text"
                className="form-control"
                id="technicalSpecifications"
                name="technicalSpecifications"
                value={formData.technicalSpecifications}
                onChange={handleChange}
                required
                placeholder="Ex: Capacité de 3000 mAh"
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="technicalSpecificationsConfidential"
                name="technicalSpecificationsConfidential"
                checked={formData.technicalSpecificationsConfidential}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}
        <div className="btn-wrapper">
          {!loading && !docIsSaved && (
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isFormValid() || loading}
            >
              Enregistrer le produit
            </button>
          )}
          {loading && (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default Step1Form;
